import { render, staticRenderFns } from "./motDevolucion.vue?vue&type=template&id=6e8a77ad"
import script from "./motDevolucion.vue?vue&type=script&lang=js"
export * from "./motDevolucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports